import React from 'react';

import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';
import { ExternalLink } from './ExternalLink';

export const LE2_3 = () => (
  <Section>
    <UL>

      <LI>
        Erweiterung: Falls bisher nicht angesprochen, diskutieren Sie das Thema Finanzen mit den SuS: Wer zahlt, hat Einfluss auf die Kaufentscheidung?
      </LI>

      <LI gapBefore>
        Abschließend bietet sich ein Vergleich der Ergebnisse in der Klasse mit jenen der Greenpeace-Studie an (&#8222;Usage & Attitude: Mode unter Jugendlichen” von 2015). Ist das Ergebnis ähnlich?
        <br />
        <ExternalLink href="https://www.greenpeace.de/sites/www.greenpeace.de/files/publications/mode-unter-jugendlichen-greenpeace-umfrage.pdf" />
        (v. a. Schaubild S. 8: Finanzen; Schaubild S. 13: Informationsquellen für Modetrends)
      </LI>

      <LI gapBefore>
        Einfluss von Freunden bei der Kaufentscheidung
        <br />
        Gestalten Sie ein <b>Rollenspiel</b>, das den SuS den Einfluss ihrer Freundinnen und Freunde auf die eigene Kaufentscheidung verdeutlicht. Alle SuS sollen ein T-Shirt mit in den Unterricht bringen. Stellen Sie 3 bis 4 Einkaufssituationen nach: Eine Schülerin bzw. ein Schüler kann ein T-Shirt “kaufen” und sich hierbei von einer Freundin bzw. einem Freund beraten lassen. Dieser erhält eine Handlungsanweisung, z. B.:
        <UL disc gapAfter>
          <LI>Ich argumentiere gegen alle Artikel.</LI>
          <LI>Ich unterstütze den Kauf aller Artikel.</LI>
          <LI>Ich unterstütze den Kauf des 3. Artikels.</LI>
        </UL>
        Halten Sie die SuS an, möglichst authentisch ihre Rolle auszufüllen. Nach jedem Spiel können sich die &#8222;Testpersonen” Notizen machen: Wie haben sie sich mit der Beratung (als Unterstützung, Korrektiv?) gefühlt? 
        Werten Sie gemeinsam aus: Wie wichtig ist Bestätigung/Ablehnung eines Artikels durch Freunde für die eigene Kaufentscheidung?
      </LI>

      <LI gapBefore>
        Orientierungshilfen aus den Medien
        <br />
        Gestalten Sie mit den SuS eine <b>Wandzeitung</b>, auf der das Wo, Wer und Wie der Orientierungshilfe erarbeitet und verdeutlicht wird. Die SuS sollen jeweils ein bis zwei Beiträge aus Zeitschriften oder anderen Medien (als Screenshots) mitbringen, die sie hilfreich finden. Auf jedem Beitrag wird die Quelle vermerkt, eine Verbindung zu einzelnen SuS sollte nicht erkennbar sein (Anonymisierung!). Nach gemeinsamer Sichtung wird zugeordnet:
        <UL disc gapAfter>
          <LI>Gruppieren Sie gemeinsam die Beiträge nach dem Ort der Veröffentlichung (Zeitschriften, soziale Netzwerke, Fernsehen u. a.),</LI>
          <LI>dann sollen die Verfasser der Beiträge (Journalist, Influencer, Promi) in verschiedenen Farben dazugeschrieben werden.</LI>
          <LI>Schließlich beschriften die SuS die Formen der Orientierungshilfe (Bewertung, Beschreibung eines Looks, Darstellung auf Foto).</LI>
        </UL>
        Dann können die SuS die Beiträge der Wandzeitung &#8222;liken”, z. B. mit jeweils drei roten und drei grünen Punkten: Welcher Beitrag ist besonders hilfreich? Welcher nicht? Vorlieben werden deutlich.
      </LI>

      <LI gapBefore>
        Die Bedeutung der Influencer
        <br />
        Beim Influencer-Screening hilft die Wandzeitung zur Unterscheidung zwischen Influencern (nur soziale Netzwerke)
        und Prominenten (nutzen auch diese Kanäle, erhalten aber ihre Prominenz durch andere Berufe und Leistungen).
        Oder Sie führen ein Statement des Fußballers Jerome Boateng an&nbsp;
        <ExternalLink href="https://www.bpb.de/lernen/formate/142180/modekonsum" />,
        um dann auf das Leben und die Arbeit von Influencern zu blicken:
        <UL disc gapAfter>
          <LI>Caro Daur&nbsp;<ExternalLink href="https://www.instagram.com/carodaur/" /></LI>
          <LI>Lisa und Lena&nbsp;<ExternalLink href="https://www.instagram.com/Lisaandlena/" /></LI>
          <LI>Riccardo Simonetti&nbsp;<ExternalLink href="https://www.instagram.com/riccardosimonetti/" /></LI>
        </UL>
        Welcher Arbeit gehen die Influencer nach? Welchen Eindruck vermitteln die Bilder? Antworten könnten sein: ein unbeschwertes, schillerndes Leben (Urlaub, Luxus, Partys in immer tollen Outfits), an dem durch tägliche Posts alle teilhaben können. Tags auf Modelabels oder Empfehlungen bilden die Verbindung zwischen diesem unbeschwerten Leben und der eigenen (weniger glamourösen) Lebenswelt.
      </LI>

      <LI gapBefore>
        Eine Frage der Glaubwürdigkeit:
        <br />
        Folgend können <b>Alltag und Praktiken</b> der Influencer in Gruppen untersucht werden:
        <UL disc gapAfter>
          <LI>zu Caro Daur (Welche Fragen beantwortet sie nicht?)&nbsp;<ExternalLink href="https://www.manager-magazin.de/unternehmen/karriere/caro-daur-die-instagram-influencerin-im-interview-a-1155194-2.html" /></LI>
          <LI>Journalistin versucht sich als Influencerin&nbsp;<ExternalLink href="https://www.wiwo.de/erfolg/trends/nicht-nackig-genug-der-schwere-weg-zum-social-media-star/19819542-all.html" /></LI>
          <LI>Kategorisierung von Influencern nach &#8222;Lovers”, &#8222;Critics” und &#8222;Mavens”:&nbsp;<ExternalLink href="https://www.internetworld.de/onlinemarketing/influencer/elfte-deutsche-influencer-944588.html" /></LI>
          <LI>Kritik an der unklaren Grenze zwischen Kunden und Vermarktern&nbsp;<ExternalLink href="https://www.spiegel.de/wissenschaft/mensch/influencer-der-markt-frisst-seine-kinder-kolumne-a-1206170.html" /></LI>
        </UL>
        Diskutieren Sie mit den SuS: Welche Zusammenhänge sind neu? Vertrauen sie Influencern und wie bewerten sie deren Empfehlungen?
      </LI>

      <LI gapBefore>
        Vertiefung: <b>Vergleichen</b> Sie unterschiedliche Studien zum Thema Influencer:
        <UL disc gapAfter>
          <LI>Wer sind die Auftraggeber?</LI>
          <LI>Welche Gruppe von Jugendlichen wird untersucht?</LI>
          <LI>Wie viele werden befragt?</LI>
          <LI>Mit welchem Ergebnis?</LI>
        </UL>
        Usage & Attitude-Studie von Greenpeace aus dem Jahr 2015:<br />
        <ExternalLink href="https://www.greenpeace.de/sites/www.greenpeace.de/files/publications/mode-unter-jugendlichen-greenpeace-umfrage.pdf" />
        (v. a. S. 13) und Influry-Studie von 2017:<br />
        <ExternalLink href="https://www.horizont.net/marketing/nachrichten/Produktempfehlungen-Influencer-sind-nach-Freunden-und-Kundenbewertungen-glaubwuerdigste-Quelle-159867" />
      </LI>

      <LI gapBefore>
        Erweiterung: Einen ganz anderen Zugang zum Thema Influencer bietet der <b>fachwissenschaftliche Beitrag</b> von Sebastian Löwe (22.10.2018), der beispielhaft an einzelnen InfluencerInnen Bildsprache, Wirkung, Schaffung von Authentizität und aktuelle Trends analysiert.
        <br />
        <ExternalLink href="http://www.pop-zeitschrift.de/2018/10/22/social-media-oktober-von-sebastian-loewe" />
        Dieser Artikel kann in einem (oder mehreren) Einzelreferat(en) oder in Gruppen erarbeitet werden.
      </LI>

      <LI gapBefore>
        <b>Streitfragen</b>: Werbung in sozialen Netzwerken
        <br />
        Zur Vorbereitung bietet es sich an, dass die SuS folgenden Text lesen:
        <br />
        <ExternalLink href="http://faktenfinder.tagesschau.de/kurzerklaert/kurzerklaert-werbung-social-media-103~_origin-9e3a5e5a-e0a5-4bef-8705-9f9636ecf64a.html" />
        <br />
        Im Unterricht können sich die SuS das Urteil im Fall der Influencerin Pamela Reif anhand eines Audiobeitrag (2 ½ Minuten) erarbeiten:
        <br />
        <ExternalLink href="https://www.tagesschau.de/inland/urteil-influencerin-pamela-reif-101.html" />
      </LI>

    </UL>
  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE2_3.js